import { useEffect, useEffectEvent, useState } from 'react';

const STORAGE_KEY = 'em.autoNext';
const AUTO_NEXT_SECONDS = 3;

// autoNextEnabled: Einstellung „Automatisch zum nächsten Lead“ (je Browser gemerkt, Standard: an).
const autoNextEnabled = () => localStorage.getItem(STORAGE_KEY) !== 'off';

// AutoNext: nach dem Speichern eines Ergebnisses nach kurzem Countdown automatisch zum nächsten Lead – abbrechbar
// (Knopf oder Escape) und abschaltbar.
export function AutoNext({ onNext, busy }: { onNext: () => void; busy: boolean }) {
  const [enabled, setEnabled] = useState(autoNextEnabled);
  const [left, setLeft] = useState(AUTO_NEXT_SECONDS);
  const [stopped, setStopped] = useState(false);
  const fire = useEffectEvent(onNext);
  const running = enabled && !stopped && !busy;

  useEffect(() => {
    if (!running) return;
    if (left <= 0) {
      fire();
      return;
    }
    const timer = setTimeout(() => setLeft((l) => l - 1), 1000);
    return () => clearTimeout(timer);
  }, [running, left]);

  useEffect(() => {
    if (!running) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setStopped(true);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [running]);

  return (
    <div className="auto-next">
      {running && (
        <p className="auto-next-status" role="status">
          Nächster Lead in {Math.max(left, 0)} s …{' '}
          <button type="button" className="btn btn-small btn-ghost" onClick={() => setStopped(true)}>
            Abbrechen <kbd>Esc</kbd>
          </button>
        </p>
      )}
      <label className="checkbox">
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e) => {
            localStorage.setItem(STORAGE_KEY, e.target.checked ? 'on' : 'off');
            setEnabled(e.target.checked);
            setStopped(!e.target.checked);
            setLeft(AUTO_NEXT_SECONDS);
          }}
        />{' '}
        Automatisch zum nächsten Lead
      </label>
    </div>
  );
}
